import React from 'react';

export default function WordCloud({ words, maxWords = 6 }) {
  if (!words || words.length === 0) return null;

  const top = words.slice(0, maxWords);
  const maxCount = top[0]?.count ?? 1;

  return (
    <div className="word-cloud" aria-label="Top words in this episode">
      <div className="word-cloud__header">
        <span className="word-cloud__heading" aria-hidden="true">Top words</span>
        <button
          className="stat-row__help"
          data-tooltip="Most frequent words spoken across the episode."
          aria-label="Explain top words"
          type="button"
        >
          ?
        </button>
      </div>
      <div className="word-cloud__pills">
        {top.map(({ word, count }) => (
          <span
            key={word}
            className="word-cloud__pill word-cloud__pill--major"
            title={`"${word}" used ${count} times`}
          >
            {word}
            <span className="word-cloud__count" aria-hidden="true">{count}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
